import { render, staticRenderFns } from "./ReportsSentEstimatesStat.vue?vue&type=template&id=226383b6&"
import script from "./ReportsSentEstimatesStat.vue?vue&type=script&lang=js&"
export * from "./ReportsSentEstimatesStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports